export default __webpack_public_path__ + "static/media/l11.a9a33e34.png";